import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["colgroup", "Table", "head", "body", "foot", "scrollable", "height", "ScrollContainer"];
import { forwardRef } from 'react';
import styled from 'foundations-theming/utils';
import { ScrollContainer as ScrollContainerComponent } from '../ScrollContainer';
import { Section } from '../Section';
import { filterProps } from '../../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import { useTableContext } from './TableContext';
import { deepMerge } from '../../utils/deepMerge';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const StyledTable = styled.table.withConfig({
  displayName: "AbstractTable__StyledTable",
  componentId: "br4fwo-0"
})(({
  $cssStyles,
  $styleOverrides
}) => {
  return deepMerge($styleOverrides, $cssStyles);
});
export const AbstractTable = /*#__PURE__*/forwardRef((props, ref) => {
  const {
      colgroup,
      Table = StyledTable,
      head,
      body,
      foot,
      scrollable,
      height,
      ScrollContainer = ScrollContainerComponent
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const {
    tableVariantStyleOverrides
  } = useTableContext();
  const {
    domProps,
    tokenProps,
    callbackProps,
    restProps
  } = filterProps(rest);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  const renderedTable = /*#__PURE__*/_jsxs(Table, Object.assign({}, domProps, callbackProps, restProps, {
    $cssStyles: cssStyles,
    $styleOverrides: tableVariantStyleOverrides !== null && tableVariantStyleOverrides !== void 0 ? tableVariantStyleOverrides : {},
    ref: ref,
    children: [colgroup, head, foot, body]
  }));
  return scrollable ? /*#__PURE__*/_jsx(Section, {
    height: height,
    flush: true,
    children: /*#__PURE__*/_jsx(ScrollContainer, {
      scrollDirection: height != null ? 'both' : 'horizontal',
      maxHeight: height != null ? height : undefined,
      children: renderedTable
    })
  }) : renderedTable;
});
AbstractTable.displayName = 'AbstractTable';